import React from "react";
import "../../assets/css/seller-banner-ads.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Seller_sidebar from "./Seller-sidebar/Seller_sidebar";
import Seller_tabs_list from "./Seller-sidebar/Seller_tabs_list";
import { ad1 } from "../../constants";
import SellerHeader from "../../components/SellerHeader/SellerHeader";
import SellerFooter from "../../components/SellerFooter/SellerFooter";

const Seller_banner_ad = () => {
	return (
		<>
			{/* Header starts here */}
			<SellerHeader />
			{/* Header ends here */}
			<section className="dashboard">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<Seller_sidebar />
						</div>
						<div className="col-lg-8">
							<Seller_tabs_list />
							{/* View banner ads starts here */}
							<div className="banner-ads">
								<div className="view-banner-ads-heading-wrapper">
									<h2>View Banner Ads</h2>
									<h4>( 02 )</h4>
								</div>
								<div className="view-card-wrapper">
									<div className="ads-content-wrapper">
										<div className="ads-date-list-wrapper">
											<div className="single-date-wrapper">
												<div className="date">
													<h5>Start Date</h5>
													<h6>12 _ Nov _2022</h6>
												</div>
											</div>
											<div className="single-date-wrapper">
												<div className="date">
													<h5>End Date</h5>
													<h6>22 _ Nov _2022</h6>
												</div>
											</div>
											<div className="single-date-wrapper">
												<div className="date">
													<h5>Banner Price</h5>
													<h6>$ 40.00</h6>
												</div>
											</div>
										</div>
										<div className="ads-brand-link-wrapper">
											<label htmlFor="">Your Brand Link </label>
											<div className="fields-wrapper">
												<input
													type="text"
													placeholder="Lorem ipsum dolor sit amet, consectetur "
													className="form-control"
												/>
												<button className="btn"> Copy Link</button>
											</div>
										</div>
									</div>
									<div className="ads-img-wrapper">
										<div className="ad-img">
											<figure>
												<img src={ad1} className="img-fluid" alt="" />
											</figure>
											<div className="btn-wrapper d-flex justify-content-between w-100 align-items-center px-3">
												<a href="/edit-ad-form" className="edit-btn">
													Edit Ads
												</a>
												<button className="delete">
													<i className="fa fa-trash"></i>
												</button>
											</div>
										</div>
										<div className="expire-date-wrapper">
											<h6>Expire Date :</h6>
											<h6>10 Nov 2022</h6>
										</div>
									</div>
								</div>
								<div className="view-card-wrapper">
									<div className="ads-content-wrapper">
										<div className="ads-date-list-wrapper">
											<div className="single-date-wrapper">
												<div className="date">
													<h5>Start Date</h5>
													<h6>12 _ Nov _2022</h6>
												</div>
											</div>
											<div className="single-date-wrapper">
												<div className="date">
													<h5>End Date</h5>
													<h6>22 _ Nov _2022</h6>
												</div>
											</div>
											<div className="single-date-wrapper">
												<div className="date">
													<h5>Banner Price</h5>
													<h6>$ 40.00</h6>
												</div>
											</div>
										</div>
										<div className="ads-brand-link-wrapper">
											<label htmlFor="">Your Brand Link </label>
											<div className="fields-wrapper">
												<input
													type="text"
													placeholder="Lorem ipsum dolor sit amet, consectetur "
													className="form-control"
												/>
												<button className="btn"> Copy Link</button>
											</div>
										</div>
									</div>
									<div className="ads-img-wrapper">
										<div className="ad-img">
											<figure>
												<img src={ad1} className="img-fluid" alt="" />
											</figure>
											<div className="btn-wrapper d-flex justify-content-between w-100 align-items-center px-3">
												<a href="/edit-ad-form" className="edit-btn">
													Edit Ads
												</a>
												<button className="delete">
													<i className="fa fa-trash"></i>
												</button>
											</div>
										</div>
										<div className="expire-date-wrapper">
											<h6>Expire Date :</h6>
											<h6>10 Nov 2022</h6>
										</div>
									</div>
								</div>
								<div className="upload-btn-wrapper">
									<a href="/banner-ad-form#" className="btn">
										Upload New Banner
									</a>
								</div>
							</div>
							{/* View banner ads ends here */}
						</div>
					</div>
				</div>
			</section>
			{/* Footer starts here */}
			<SellerFooter />
			{/* Footer ends here */}
		</>
	);
};

export default Seller_banner_ad;
